import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from '../../../utils/dateFormat';
import { Loading } from '../../common/Loading';

const formatDate = (date, format = 'MMM D YYYY h:mm a ([GMT]Z)') => {
  date = parseInt(date, 10);
  return dateFormat(date * 1000, format);
};

const AutomatedReportsTable = ({ alerts, onRemoveButtonClick, isLoading }) => {
  const columns = ['Rule', 'Filters', 'Last run', 'Created', 'Operation'];

  return (
    <table>
      <thead>
        <tr>
          {columns.map(column => <th key={column}>{column}</th>)}
        </tr>
      </thead>
      <tbody>
        {isLoading || alerts.length === 0
          ? (
            <tr>
              <td colSpan="100%">
                {isLoading
                  ? <Loading show={isLoading} type="bar" />
                  : 'No Active or Pending Rules'
                }
              </td>
            </tr>
          ) : (
            alerts.map(alert => (
              <tr key={alert.rtalert_cron_id}>
                <td>
                  Start on <strong>{formatDate(alert.time_start)}</strong><br />
                  Until <strong>{formatDate(alert.time_end)}</strong><br />
                  Every <strong>{alert.interval_str}</strong>
                </td>
                <td>
                  court <strong>{alert.court_code}</strong>
                  {Object.keys(alert.search_params).map(key => (
                    !!alert.search_params[key] &&
                    <div key={key}>
                      {key} <strong>{alert.search_params[key]}</strong>
                    </div>
                  ))}
                </td>
                <td>
                  {alert.time_last_run !== '0' ? formatDate(alert.time_last_run) : 'Never'}
                </td>
                <td>
                  {formatDate(alert.created, 'MM/DD/YYYY')} by<br />
                  {/* eslint-disable react/no-danger */}
                  <div dangerouslySetInnerHTML={{ __html: alert.creator_name }} />
                </td>
                <td style={{ textAlign: 'center' }}>
                  {alert.isBeingRemoved
                    ? <Loading show={alert.isBeingRemoved} type="spinner" />
                    : <a href="#"
                         onClick={(e) => {
                           e.preventDefault();
                           onRemoveButtonClick(alert.rtalert_cron_id);
                         }}
                         className="form-submit button-red"
                         style={{ width: 'auto' }}
                      >
                        Remove
                      </a>
                  }
                </td>
              </tr>
            ))
          )
        }
      </tbody>
    </table>
  );
};

AutomatedReportsTable.propTypes = {
  alerts: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onRemoveButtonClick: PropTypes.func,
};

AutomatedReportsTable.defaultProps = {
  onRemoveButtonClick: () => {},
};

export default AutomatedReportsTable;



/** WEBPACK FOOTER **
 ** ./src/components/searchAlerts/AutomatedReports/AutomatedReportsTable.jsx
 **/